// src/components/common/SuccessModal.tsx
import React from 'react';

interface SuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  message: string;
  buttonText?: string;
}

const SuccessModal: React.FC<SuccessModalProps> = ({ 
  isOpen, 
  onClose, 
  title, 
  message, 
  buttonText = 'OK' 
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 transition-opacity duration-300 ease-in-out">
      <div className="bg-theme-bg-secondary dark:bg-dark-theme-bg-secondary p-6 sm:p-8 rounded-lg shadow-xl w-full max-w-md mx-4 transform transition-all duration-300 ease-in-out scale-100">
        <div className="text-center">
          <h3 className="text-xl sm:text-2xl font-semibold text-theme-text dark:text-dark-theme-text mb-4">
            {title}
          </h3>
          <p className="text-sm sm:text-base text-theme-text-secondary dark:text-dark-theme-text-secondary mb-6 whitespace-pre-line">
            {message}
          </p>
        </div>
        <div className="mt-5 sm:mt-6">
          <button
            type="button"
            className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-gradient-button text-white text-base font-medium hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-light dark:focus:ring-primary-dark sm:text-sm transition-opacity duration-150"
            onClick={onClose}
          >
            {buttonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;
